import { validationTypes } from "../../../components/FinalForms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../data/formFieldType";
import { GridColumnType } from "../../../data/gridColumnType";

const initState = {
  subSkillName: ""
};

const SubSkillDataFields = {
  name: "Add Candidate",
  initialState: initState,
  section: [
    {
      title: "Add candidate Section",
      row: {},
      style: {
        sectionStyle: "row",
      },
      fields: [
        {
          id: "subSkillName",
          label: "Sub Skill Name",
          Field_Name: "Sub Skill Name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "subSkillName",
          fieldSetting: {
            placeholder: "Please Enter Skill Name",
            // isMultiSelect: true,
            options: [],
            maxLength: 50,
          },
          changeAction: {
            resetValue: [
              {
                dataField: "subSkillName",
                value: null
              }
            ]
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-md-12 mb-2",
          },
        },
        {
          id: "description",
          label: "Description",
          Field_Name: "Description",
          fieldType: FormFieldTypes.TEXTAREA,
          dataField: "description",
          fieldSetting: {
            placeholder: "Enter Description",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-md-12 mb-2",
          },
        },

      ],
    }
  ],formSetting: {
    isViewOnly: false,
}
};

export default SubSkillDataFields;




//** Table columns configuration */
export const SubSkillGridConfig = {
  columns: [
    // {
    //   name: "Main Skill ",
    //   fieldName: "mainSkillName",
    //   allowShort: false,
    // },
    {
      name: "Sub Skill Name",
      fieldName: "subSkillName",
      allowShort: false,
    },
    {
      name: "Description",
      fieldName: "description",
      allowShort: false,
    },
    {
      name: " Date",
      fieldName: "createdAt",
      colType: GridColumnType.DATE,
      colSettings: {
        isUTC: true,
        format: "DD/MM/YYYY hh:mm A ",
      },
    },

    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
    },
    },
  ],
}